import { useEffect, useRef } from "react";
import { Box, useColorMode } from "@chakra-ui/react";

const NUM_STARS = 100;

export default function StarryBackground() {
  const { colorMode } = useColorMode();
  const starColor = colorMode === "light" ? "#98c9a3" : "#e9a6a6";
  const bgColor = colorMode === "light" ? "#fff4ec" : "#1F1D34";

  const containerRef = useRef();
  const starsRef = useRef([]);

  // Initialize stars with random positions and speeds
  useEffect(() => {
    const stars = Array.from({ length: NUM_STARS }).map(() => {
      const speed = 0.2 + Math.random() * 0.6;
      const size = 1 + 4 * speed;
      return {
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        speed: speed,
        size: size,
        // size: 2 - speed,
      };
    });

    starsRef.current = stars;
  }, []);

  // Animate using requestAnimationFrame
  useEffect(() => {
    let animationFrameId;

    const animate = () => {
      const canvas = containerRef.current;
      if (!canvas) return;

      starsRef.current = starsRef.current.map((star) => {
        let newY = star.y + star.speed;
        if (newY > window.innerHeight) {
          newY = 0;
        }
        return { ...star, y: newY };
      });

      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        starsRef.current.forEach((star) => {
          ctx.beginPath();
          ctx.arc(star.x, star.y, star.size, 0, 2 * Math.PI);
          ctx.fillStyle = starColor;
          ctx.fill();
        });
      }

      // Schedule next frame and save its ID
      animationFrameId = requestAnimationFrame(animate);
    };

    const canvas = containerRef.current;
    if (canvas) {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      animate();
    }

    const handleResize = () => {
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup: cancel the animation frame and remove the event listener
    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", handleResize);
    };
  }, [starColor]);

  return (
    <Box
      as="canvas"
      bg={bgColor}
      ref={containerRef}
      position="absolute"
      top={0}
      left={0}
      w="100%"
      h="100%"
      zIndex={-1}
      pointerEvents="none"
    />
  );
}
